import { IUser } from "@logex/framework/lg-application";

export class AppUser implements IUser {
    id: number;
    name: string;
    email: string;
    login: string;
    impersonator: string;
    isInternal: boolean;
    roles: Record<string, boolean>;
    title: string;
    userid: string;
    ziekenhuiscode: number;
    ziekenhuisnaam: string;

    viewSpecialisms: Set<number>;
    viewDiagnosisGroups: Set<number>;
    hospitalCode: number;

    constructor() {
        this.roles = {};
    }

    public hasPermission(role: string): boolean {
        return this.roles[role] || false;
    }
}
